<template>
    <div class="dial-radial-bar-sparkline" ref="el">

        <div style="position: relative;" >
            <apexchart ref="chartRef" class="dial-chart" width="100%" type="radialBar" :options="options" :series="series" style="position: block;"></apexchart>
            <i
                class="fa-solid fa-long-arrow-alt-up fa-2xs"
                :style="`
                        font-size: ${arrowIconSize};
                        color: ${arrowColor};
                        position: absolute;
                        top: 90%;
                        left: 50%;
                        transform: translate(-50%,-90%) rotate(${rotation}deg);
                        transform-origin: 50% 100%
                    `"
            >
            </i>
        </div>
        <div v-if="displayIcons === true" style="margin-top: -2px;">
            <div class="icon-style icon-style-left" :style="`font-size: ${iconSize};`"><i class="fas fa-democrat fa-sm" style="color: rgb(10, 10, 132);"></i>
            </div><div class="icon-style icon-style-right"  :style="`font-size: ${iconSize};`"><i class="fas fa-republican fa-sm" style="color: rgb(150, 32, 32);"></i></div>
        </div>
    </div>
</template>

<script setup>
    import { computed, onMounted, onUnmounted, ref } from 'vue';
    import styles from '../../../sass/_export.module.scss';

    const props = defineProps({
        rotation: {required: true, default: 90, type: Number},
        displayIcons: {required: false, default: true, type: Boolean},
    });

    const el = ref(null);
    const chartRef = ref(null);
    let observer = null;

    onMounted(() => {
        console.log('DialRadialBarSparkline Component mounted.');
        resizeComponent();
        window.addEventListener("resize", resizeComponent);

        // Set up Intersection Observer to detect when component becomes visible
        observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Component is now visible - trigger resize and chart update
                    setTimeout(() => {
                        resizeComponent();
                        if (chartRef.value) {
                            chartRef.value.updateOptions(options.value);
                        }
                    }, 50);
                }
            });
        }, { threshold: 0.1 });

        if (el.value) {
            observer.observe(el.value);
        }
    });

    onUnmounted(() => {
        window.removeEventListener("resize", resizeComponent);
        if (observer && el.value) {
            observer.unobserve(el.value);
        }
    });

    const arrowColor = computed(() => {
        if (props.rotation === 0) {
            return styles.gray700;
        }
        else if (props.rotation < 0) {
            return styles.demColor1;
        }
        else {
            return styles.repColor1;
        }
    });

    const width = computed({
        get()  {
            return  debouncedWidth.value;
        },
        set(val)  {
            if  (widthTimeout.value) {
                clearTimeout(widthTimeout.value);
            }
            widthTimeout.value =  setTimeout(()  =>  {
                debouncedWidth.value = val;
            },  500);
        },
    });

    const iconSize = computed(() => {
        return (0.6 + (0.006*width.value)) + 'rem';
    });

    const arrowIconSize= computed(() => {
        return (width.value/5.4) + 'px';
    });

    function resizeComponent() {
        if (el.value !== null) {
            width.value =  el.value.offsetWidth;
        }
    }

    const debouncedWidth = ref(0);
    const widthTimeout = ref(null);
    const options = ref({
        chart: {
            type: "radialBar",
            sparkline: {
                enabled: true
            },
            animations: {
                enabled: false,
                dynamicAnimation: {
                    enabled: false,
                }
            },
        },
        states: {
            hover: {
                filter: {
                    type: 'none'
                }
            }
        },
        colors: [styles.bodyBg],
        plotOptions: {
            radialBar: {
                startAngle: -90,
                endAngle: 90,
                track: {
                    margin: 0,
                    background: styles.bodyBg,
                    startAngle: -90,
                    endAngle: 90,
                },
                dataLabels: {
                    name: {
                    show: false,
                    },
                    value: {
                    fontSize: "1rem",
                    show: false
                    }
                }
            }
        },
        fill: {
            type: "gradient",
            gradient: {
            shade: "dark",
            type: "horizontal",
            colorStops: [
                {
                    offset: 0,
                    color: styles.demColor1,
                    opacity: 1
                },
                {
                    offset: 50,
                    color: styles.gray400,
                    opacity: 1
                },
                {
                    offset: 100,
                    color: styles.repColor1,
                    opacity: 1
                }
            ],
            stops: [0, 100]
            }
        },
        stroke: {
            lineCap: "butt",
            dashArray: 2
        },
        labels: ["Progress"]
    });
    const series = ref([100]);
</script>
<style>
.dial-radial-bar-sparkline {
    font-size: 16px;
    min-width: 56px;
}
.icon-style {
    display:inline-block;
    width: 50%;
    text-align: center;
}
.icon-style-left {
    text-align: left;
}
.icon-style-right {
    text-align: right;
}
</style>